module.exports = __webpack_public_path__ + "static/media/Benevity.ae083501.png";